/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Error_FailedInputs */



/**
* | output |
* | --- |
* | "Verification failed" |
*
* @param {Auth_Verify_Error_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_error_failed = /** @type {((inputs?: Auth_Verify_Error_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Error_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la vérification")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de verificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha na verificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica fallita")
	return /** @type {LocalizedString} */ ("Verification failed")
});